export default __webpack_public_path__ + "static/media/XEMP-3.5fa314f8.jpg";